
import { doPolling } from '@ilyagershman/easy-poll';

interface Response {
  data: any | null;
  error: { code: number; message: string; missing_ukids?: string[] } | null;
}

export const useQuoteListener = async (transactionId: string, providerList: Array<any>): Promise<Response> => {
  const cart = useCart();
  const initialProviderList = Array.isArray(providerList) && providerList.length
    ? providerList
    : cart.items.map((item: any) => ({
        Id: item?.provider?.id,
        Ukid: item?.provider?.ukid,
      }));

  const normalizedProviderList = initialProviderList
    .map((provider: any) => ({
      Id: provider?.Id ?? provider?.id ?? provider?.provider?.id ?? null,
      Ukid: provider?.Ukid ?? provider?.ukid ?? provider?.provider?.ukid ?? null,
    }))
    .filter((provider: any) => !!provider.Id);

  const uniqueProviderIds = [...new Set(normalizedProviderList.map((provider: any) => provider.Id))];
  const requestCount = uniqueProviderIds.length || cart.transaction_id_count || 1;

  try {
    const apiResult: any = await doPolling(
      () => $apiServer('/quotes', { query: { transaction_id: transactionId, count: requestCount } }),
      {
        maxPolls: 10,
        maxErrors: 5,
        interval: 1500,
        until: (result: any) => {
          const selectList = Array.isArray(result?.data?.data) ? result.data.data : [];
          return selectList.length === cart.transaction_id_count;
        }
      }
    ).init();

    const { data } = apiResult ?? {};
    const selectList = Array.isArray(data?.data) ? data.data : [];
    let errorDetail: { code: number; message: string; missing_ukids: string[] } | null = null;
    const errorExist = selectList.find((k:any) => k.error);

    const missingIds = uniqueProviderIds
      .filter((id: string) => !selectList.map((item: any) => item.provider.id).includes(id));

    const missingUkids = normalizedProviderList
      .filter((provider: any) => missingIds.includes(provider.Id))
      .map((provider: any) => provider.Ukid)
      .filter(Boolean);

    if (selectList.length !== cart.transaction_id_count) {
      errorDetail = { code: 101, message: 'Unable to contact sellers' , missing_ukids: missingUkids};
    } else if (errorExist) {
      errorDetail = {
        code: Number(errorExist.error.code),
        message: errorExist.error.message
      };
    }
    const onSelectIds = new Set();
    const uniqueOnSelect = selectList.filter(item => {
     const key = `${item.transaction_id}-${item.provider.id}`;
     if (onSelectIds.has(key)) return false;
     onSelectIds.add(key);
     return true;
    });

    return { data: uniqueOnSelect, error: errorDetail };
  } catch (error: any) {
    console.error('Error in useQuoteListener:', error.message);
    return { data: null, error: { code: 500, message: error.message } };
  }
};
